<template>
    <div class="simple-form">
        <el-form :model="devcDef" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="content-caption dashed">
                <span>基本信息</span>
            </div>
            <div class="form-group" v-if="devcDef.assetType != null">
                <div class="form-label">
                    <label class="required">定义编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="innerCode" :rules="{validator: checkModel, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.innerCode"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">资产品牌</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="innerDevcBrandName">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.innerDevcBrandName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectInnerBrandDlg()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name" :rules="{validator: checkNullModel, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.name" @change="titleChange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">型号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="model" :rules="{validator: checkNullModel, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.model" @change="titleChange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">规格</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="fixedSpec" :rules="{validator: checkNullModel, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.fixedSpec" @change="titleChange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">单位</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="theUnit" :rules="{validator: checkModel, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.theUnit"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group top">
                <div class="form-label">
                    <label>图片</label>
                </div>
                <div class="form-value">
                    <swb-file-upload :fileFor="'image-misc'" fileGroup="image-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                    <div v-if="imgFile != null" class="file-area clearfix">
                        <span v-if="imgFile.fileBrowseUrl != null && imgFile.fileBrowseUrl != ''">
                            <swb-file-item :fileUuid="imgFile.fileUuid" :fileBrowseUrl="imgFile.fileBrowseUrl" :deletable="true" :onDelete="removeUpload"></swb-file-item>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">资产描述全称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="title" :rules="{validator: checkTitle, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.title"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">资产分类</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="innerDevcCatName">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.innerDevcCatName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectInnerCatDlg()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>管理信息</span>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>使用方式</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="useManner">
                        <el-select v-model="devcDef.useManner" placeholder="请选择">
                            <el-option v-for="item in devcUseMannerList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="!assetTypeDisabled">
                <div class="form-label">
                    <label>资产管理方式</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="assetType">
                        <el-radio-group :disabled="assetTypeDisabled" v-model="devcDef.assetType" @change="selectAssetType">
                            <el-radio :label=0>单品式</el-radio>
                            <el-radio :label=1>批量式</el-radio>
                            <!--<el-radio :label=2>耗材</el-radio>-->
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>按金额管理</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="splitible">
                        <el-radio-group v-model="devcDef.splitible">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="normalFlag">
                <div class="form-label">
                    <label class="required">定义完善程度</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="normalized">
                        <el-radio-group v-model="devcDef.normalized" :disabled="disableNormalized" @change="normalizedChange">
                            <el-radio :label="true">在账资产</el-radio>
                            <el-radio :label="false">账外设备</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="normalFlag && devcDef.normalized">
                <div class="form-label">
                    <label>资产属性</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="assetNature">
                        <span v-if="devcDef.assetNature != null && devcDef.assetNature != 0">{{ assetNatureMap[devcDef.assetNature] }}</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group" v-if="normalFlag && devcDef.normalized">
                <div class="form-label">
                    <label>财务类别</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="assetKindId">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.assetKindName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectAssetKind()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>维保分组</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="devcGroupId">
                        <el-select v-model="devcDef.devcGroupId" placeholder="请选择" filterable @change="changeDevcGroup">
                            <el-option v-for="item in devcGroupList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group top" v-if="devcCustTag1.enabled">
                <div class="form-label">
                    <label>{{ devcCustTag1.dispName }}</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="memo">
                        <el-select v-model="devcDef.devcCustTag1" placeholder="请选择" style="width: 150px" clearable>
                            <el-option v-for="item in devcCustTag1.itemList" :label="item.disabled?item.name+'(已禁用)':item.name" :value="item.id" :disabled="item.disabled"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group top" v-if="devcCustTag2.enabled">
                <div class="form-label">
                    <label>{{ devcCustTag2.dispName }}</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="memo">
                        <el-select v-model="devcDef.devcCustTag2" placeholder="请选择" style="width: 150px" clearable>
                            <el-option v-for="item in devcCustTag2.itemList" :label="item.disabled?item.name+'(已禁用)':item.name" :value="item.id" :disabled="item.disabled"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group top" v-if="devcCustTag3.enabled">
                <div class="form-label">
                    <label>{{ devcCustTag3.dispName }}</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="memo">
                        <el-select v-model="devcDef.devcCustTag3" placeholder="请选择" style="width: 150px" clearable>
                            <el-option v-for="item in devcCustTag3.itemList" :label="item.disabled?item.name+'(已禁用)':item.name" :value="item.id" :disabled="item.disabled"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>采购信息</span>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>仅用于临采</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="tempOnly">
                        <el-radio-group v-model="devcDef.tempOnly" :disabled="tempOnlyDisabled" @change="changegTempOnly">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>用于采购</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="splitible">
                        <el-radio-group v-model="devcDef.purchFlag" :disabled="purchFlagDisabled" @change="changePurchFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div v-if="devcDef.purchFlag" class="form-group center">
                <div class="form-label">
                    <label>必须集中采购</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="centBuyRequired">
                        <el-radio-group v-model="devcDef.centBuyRequired">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="devcDef.assetType == 0">
                <div class="form-label">
                    <label>需要安装</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="setupFlag">
                        <el-radio-group v-model="devcDef.setupFlag" @change="flagChange">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="devcDef.assetType == 0">
                <div class="form-label">
                    <label>需要供应商提供唯一标识码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="vendorUknoFlag">
                        <el-radio-group v-model="devcDef.vendorUknoFlag" :disabled="vendorUknoFlagDisabled">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="devcDef.assetType != 2 && assetFifoInvolved">
                <div class="form-label">
                    <label>先进先出</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="stockFifo">
                        <el-radio-group v-model="devcDef.stockFifo">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>折旧与分摊规则</span>
            </div>
            <div class="form-group" v-if="devcDef.assetType != 2">
                <div class="form-label">
                    <label :class="normalizedFlag ? 'required' : ''">使用年限(月)</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="durableLife" :rules="{validator: checkDurableLife, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="number" v-model="devcDef.durableLife"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group" v-if="devcDef.assetType != 2 && normalFlag && devcDef.normalized">
                <div class="form-label">
                    <label>规则名称</label>
                </div>
                <div class="form-value">
                    <span>{{ devcDef.deprSpecName || '' }}</span>
                </div>
            </div>
            <div class="form-group" v-if="devcDef.assetType != 2 && normalFlag && devcDef.normalized">
                <div class="form-label">
                    <label>规则编码</label>
                </div>
                <div class="form-value">
                    <span>{{ devcDef.deprSpecCode || '' }}</span>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>附加信息</span>
            </div>
<!--            <div class="form-group">-->
<!--                <div class="form-label">-->
<!--                    <label>商品分类</label>-->
<!--                </div>-->
<!--                <div class="form-value">-->
<!--                    <el-form-item prop="catName">-->
<!--                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.catName"></el-input>-->
<!--                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectCatDlg()"></div>-->
<!--                    </el-form-item>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="form-group">-->
<!--                <div class="form-label">-->
<!--                    <label>商品品牌</label>-->
<!--                </div>-->
<!--                <div class="form-value">-->
<!--                    <el-form-item prop="brandName">-->
<!--                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.brandName"></el-input>-->
<!--                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectBrandDlg()"></div>-->
<!--                    </el-form-item>-->
<!--                </div>-->
<!--            </div>-->
            <div class="form-group top">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="memo" :rules="{validator: checkMemo, trigger: 'blur'}">
                        <el-input class="width-2x" type="textarea" v-model="devcDef.memo" :rows="3" :maxlength="120"></el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>资料手册</span>
                <a class="swb-btn-link" @click="selectManuals()">选择</a>
            </div>
            <el-table :data="devcFiles" border style="width: 100%">
                <el-table-column align="left" prop="fileName" label="手册名称"></el-table-column>
                <el-table-column align="left" width="100" prop="innerOnly" label="使用范围">
                    <template slot-scope="scope">
                        <span v-if="scope.row.innerOnly">内部使用</span>
                        <span v-else>通用</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="100" label="操作">
                    <template slot-scope="scope">
                        <a class="swb-btn-link" @click="removeManuals(scope.row)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>

</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'
    import {openAssetKindListSelectDlg, openBrandListSelectDlg, openCategTreeSelectDlg, showDevcBrandSelectDlg, showDevcCatSelectDlg, showDevcGroupCatSelectDlg} from '../categ/selectDlg'
    import {showMerchtDevcManualSelectDlg} from './showDlg'
    import {getAssetKindList} from '../retailer/asset-comn'
    import {getMerchantBizParam} from '../asset/assetMain'

    import devcDefApi from '../../api/devcDef'
    import merchtComnApi from '../../api/merchtComn'
    import goodsCategApi from '../../api/goodsCateg'
    import custTagMeataApi from '../../api/objTagConf'

    export default {
        name: 'swb-mercht-devc-def-save',
        desc: '资产定义保存',
        props: ["defId", "row", "normalized", "assetType", "assetTypeDisabled", "purchFlagDisabled", "addVersion"],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            return {
                devcDef: {
                    baseId: null,
                    theUnit: '台',
                    assetType: 0,
                    vendorUknoFlag: false,
                    setupFlag: false,
                    asmblFlag: false,
                    asmblWhileSetup: false,
                    centBuyRequired: false,
                    splitible: false,
                    catId: null,
                    catName: null,
                    brandId: null,
                    brandName: null,
                    innerDevcCatId: null,
                    innerDevcCatName: null,
                    innerDevcCode: null,
                    innerDevcCatFullName: null,
                    innerDevcBrandId: null,
                    innerDevcBrandName: null,
                    innerDevcBrandCode: null,
                    stockFifo: false,
                    assetKindId: null,
                    assetKindName: null,
                    assetKindCode: null,
                    useManner: 0,
                    deprSpecId: null,
                    deprSpecCode: null,
                    deprSpecName: null,
                    tempOnly: false,
                    purchFlag: false,
                    devcGroupId: null
                },
                devcGroupList: [],
                selectCat: {},
                selectBrand: {},
                rules: {
                    innerDevcCatName: [{validator: checkNull, trigger: 'blur'}],
                    innerDevcBrandName: [{validator: checkNull, trigger: 'blur'}]
                },
                //
                imgFile: null,
                devcFiles: [],
                deviceKindList: [],
                assetNatureMap: getEnumMap("assetNature", "value2text"),
                devcUseMannerList: getEnumList("devcUseManner"),
                deviceKindMaps: {},
                normalizedFlag: false,
                assetFifoInvolved: false,
                dbDevcDef: null,
                autoGeneratedTitle: false,
                vendorUknoFlagDisabled: false,
                purchFlagDisabledX: false,
                tempOnlyDisabled: false,
                normalFlag: false,
                disableNormalized: false, // 是否禁用定义完善程度属性设置，编辑的时候如果是在账资产则不允许修改，要禁用
                devcCustTag1: {
                    dispName: '自定义标签1',
                    itemList: [],
                    enabled: false
                },
                devcCustTag2: {
                    dispName: '自定义标签2',
                    itemList: [],
                    enabled: false
                },
                devcCustTag3: {
                    dispName: '自定义标签3',
                    itemList: [],
                    enabled: false
                }
            }
        },
        created: function () {
            let self = this;
            this.getCustTagMetaFields();
            if (!Utils.isNoB(this.row)) {
                let devcDef = Utils.merge({}, this.row);
                let title = devcDef.name;
                if (Utils.isNoB(devcDef.title)) {
                    if (!Utils.isNoB(devcDef.model)) {
                        title = title + devcDef.model;
                    }
                    if (!Utils.isNoB(devcDef.fixedSpec)) {
                        title = title + devcDef.fixedSpec;
                    }
                    devcDef.title = title;
                }
                if (Utils.isTrue(devcDef.tempOnly)) {
                    devcDef.purchFlag = false;
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    this.purchFlagDisabled = true;
                    this.vendorUknoFlagDisabled = true;
                    this.tempOnlyDisabled = true;
                }
                if (!Utils.isNoB(devcDef.id) && devcDef.id > 0) {
                    this.tempOnlyDisabled = true;
                }
                // 通过其他业务创建定义，不允许创建临采定义，通过业务创建爱你的定义都是用于采购的，传进来的都是用于采购的定义，不可修改禁用用于采购选项
                if (Utils.isTrue(devcDef.createDef)) {
                    devcDef.tempOnly = false;
                    this.tempOnlyDisabled = true;
                    this.purchFlagDisabled = true;
                }
                //
                this.devcDef = Utils.merge({}, devcDef);
            }
            if (!Utils.isNoB(this.assetType)) {
                this.devcDef.assetType = this.assetType;
            }
            self.normalizedFlag = self.normalized;
            self.purchFlagDisabledX = self.purchFlagDisabled;
            //
            if (!Utils.isNoB(this.defId)) {
                this.getDevcDefDetail();
            } else {
                if (Utils.isNoB(this.devcDef.innerCode)) {
                    this.setInnerCode();
                }
            }
            getAssetKindList(function (dataList) {
                self.deviceKindList = dataList;
                self.deviceKindMaps = dataList.toMap("id");
            });
            // 获取集团业务参数：是否自动生成资产定义全称
            getMerchantBizParam("asset.definition.full.name.auto.generated", function (result) {
                self.autoGeneratedTitle = Utils.isTrue(result);
            }, 0);
            getMerchantBizParam("finac.mgmt.enabled", function (result) {  // 财务管理
                self.normalFlag = Utils.isTrue(result);
                if (Utils.isTrue(result) && Utils.isNoB(self.defId)) {
                    self.devcDef.normalized = true;
                }
            }, 0);
            //
            this.getAssetFifoInvolved();
            this.getDevcGroupList();
        },
        watch: {
            'devcDef.devcCustTag1'(newVal, oldVal) {
                this.devcDef.devcCustTag1 = this.filterListValue(this.devcCustTag1.itemList, newVal)
            },
            'devcDef.devcCustTag2'(newVal, oldVal) {
                this.devcDef.devcCustTag2 = this.filterListValue(this.devcCustTag2.itemList, newVal)
            },
            'devcDef.devcCustTag3'(newVal, oldVal) {
                this.devcDef.devcCustTag3 = this.filterListValue(this.devcCustTag3.itemList, newVal)
            }
        },
        methods: {
            getAssetFifoInvolved: function () {
                // 获取【管理需要用到先进先出】业务参数
                let self = this;
                let postData = {
                    code: "asset.fifo.involved"
                };
                merchtComnApi.getMerchantBizParamValue(postData, function (result) {
                    if (result.type === "info") {
                        self.assetFifoInvolved = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcGroupList: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                let postData = {
                    level: 2,
                };
                goodsCategApi.getDevcGroupListByFilter(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let devcGroupList = result.data || [];
                        //
                        self.devcGroupList = Utils.merge([], devcGroupList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectAssetType: function () {
                let self = this;
                let devcDef = self.devcDef;
                // devcDef.innerCode = null;
                if (devcDef.assetType == 2) {
                    self.normalizedFlag = true;
                } else {
                    self.normalizedFlag = self.normalized;
                }
                self.devcDef = Utils.merge({}, devcDef);
                if (Utils.isNoB(self.devcDef.innerCode)) {
                    self.setInnerCode();
                }
            },
            // 设置系统编码
            setInnerCode: function () {
                let self = this;
                let devcDef = self.devcDef || {};
                let params = {
                    assetType: self.devcDef.assetType
                };
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getDefInnerCodeByAssetType(params, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        devcDef.innerCode = result.data;
                        self.devcDef = Utils.merge({}, devcDef);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            normalizedChange: function () {
                let devcDef = this.devcDef;
                devcDef.assetKindId = null;
                devcDef.assetKindName = null;
                devcDef.assetKindCode = null;
                devcDef.assetNature = null;
                devcDef.deprSpecId = null;
                devcDef.deprSpecCode = null;
                devcDef.deprSpecName = null;
                this.devcDef = Utils.merge({}, devcDef);
            },
            //
            selectAssetKind: function () {
                let self = this;
                let devcDef = self.devcDef;
                let params = {
                    notIncludedfirstLevelFlag: true,
                    checkBox: false,
                    hasDeprSpec: true // 必须有折旧码
                };
                openAssetKindListSelectDlg(params, function (result, theDlg) {
                    theDlg.close();
                    devcDef.assetKindId = result.id;
                    devcDef.assetKindName = result.name;
                    devcDef.assetKindCode = result.code;
                    if (devcDef.assetNature != result.assetNature) {
                        devcDef.assetNature = result.assetNature;
                    }
                    devcDef.deprSpecId = result.deprSpecId;
                    devcDef.deprSpecCode = result.deprSpecCode;
                    devcDef.deprSpecName = result.deprSpecName;
                    //
                    self.devcDef = Utils.merge({}, devcDef);
                });
            },
            checkNullModel: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if (rule.field == 'name') {
                        if (value.length > 30) {
                            callback(new Error('名称最大不能超过30个字!'));
                        } else {
                            callback();
                        }
                    } else if (rule.field == 'model') {
                        if (value.length > 30) {
                            callback(new Error('型号最大不能超过30个字!'));
                        } else {
                            callback();
                        }
                    } else if (rule.field == 'fixedSpec') {
                        if (value.length > 45) {
                            callback(new Error('规格最大不能超过30个字!'));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            },
            checkModel: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if (rule.field == 'innerCode') {
                        if (value.length > 20) {
                            callback(new Error('定义编码最大不能超过20个字!'));
                        } else {
                            callback();
                        }
                    } else if (rule.field == 'theUnit') {
                        if (value.length > 5) {
                            callback(new Error('单位最大不能超过5个字!'));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            },
            checkTitle: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if (value.length > 60) {
                        callback(new Error('资产描述全称最大不能超过60个字'));
                    } else {
                        callback();
                    }
                }
            },
            checkMemo: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (value.length > 60) {
                        callback(new Error('描述最大不能超过60个字!'));
                    } else {
                        callback();
                    }
                }
            },
            checkDurableLife: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    if (this.normalizedFlag) {
                        callback(new Error('使用年限不可为空!'));
                    } else {
                        callback();
                    }
                } else {
                    let devcDef = this.devcDef;
                    if (devcDef.assetNature == 2) {
                        if (Utils.isNaturalStr(value) && value <= 9999) {
                            callback();
                        } else {
                            callback(new Error('必须为0 ~ 9999的整数!'));
                        }
                    } else {
                        if (Utils.isNaturalStr(value, true) && value <= 9999) {
                            callback();
                        } else {
                            callback(new Error('必须为1 ~ 9999的整数!'));
                        }
                    }
                }
            },
            changegTempOnly: function () {
                let devcDef = this.devcDef || {};
                if (devcDef.tempOnly) {
                    devcDef.purchFlag = false;
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    this.devcDef = Utils.merge({}, devcDef);
                    //
                    this.purchFlagDisabled = true;
                    this.vendorUknoFlagDisabled = true;
                } else {
                    if (!this.purchFlagDisabledX) {
                        this.purchFlagDisabled = false;
                    }
                    this.vendorUknoFlagDisabled = false;
                }
            },
            changePurchFlag: function () {
                let devcDef = this.devcDef || {};
                if (!devcDef.purchFlag) {
                    devcDef.centBuyRequired = false;
                    this.devcDef = Utils.merge({}, devcDef);
                }
            },
            // 选择分类
            selectCatDlg: function () {
                let self = this;
                let devcDef = self.devcDef || {};
                if (Utils.isNoB(devcDef.devcGroupId)) {
                    let selectCat = self.selectCat;
                    let selectItems = [];
                    if (!Utils.isNoB(selectCat) && selectCat.catId > 0) {
                        selectItems.push(selectCat);
                    }
                    let params = {
                        multipleSelect: false
                    };
                    openCategTreeSelectDlg(params, selectItems, function (catList) {
                        catList = catList || [];
                        let cat = catList[0];
                        self.selectCat = Utils.merge({}, cat);
                        devcDef.catId = cat.catId;
                        devcDef.catName = cat.catName;
                        if (!Utils.isNoB(cat.unit)) {
                            devcDef.theUnit = cat.unit;
                        }
                        self.devcDef = Utils.merge({}, devcDef);
                    });
                } else {
                    let params = {
                        filter: {
                            groupId: devcDef.devcGroupId,
                            level: 2
                        },
                        checkBox: false,
                    };
                    showDevcGroupCatSelectDlg(params, function (resultData, theDlg) {
                        theDlg.close();
                        self.selectCat = Utils.merge({}, resultData);
                        devcDef.catId = resultData.catId;
                        devcDef.catName = resultData.catName;
                        self.devcDef = Utils.merge({}, devcDef);
                    });
                }
            },
            changeDevcGroup: function () {
                let devcDef = this.devcDef || {};
                devcDef.catId = null;
                devcDef.catName = null;
                this.devcDef = Utils.merge({}, devcDef);
            },
            // 选择品牌
            selectBrandDlg: function () {
                let self = this;
                let devcDef = self.devcDef || {};
                if (Utils.isNoB(devcDef.catId)) {
                    MsgBox.warning("请选择分类！");
                    return;
                }
                let selectBrand = self.selectBrand;
                let selectIds = [];
                if (!Utils.isNoB(selectBrand) && selectBrand.brandId > 0) {
                    selectIds.push(selectBrand.brandId);
                }
                let params = {
                    currentCheckValue: 2,    // 分类品牌
                    selectIds: selectIds,
                    catId: devcDef.catId,
                };
                openBrandListSelectDlg(false, params, function (brand) {
                    self.selectBrand = Utils.merge({}, brand);
                    devcDef.brandId = brand.id;
                    devcDef.brandName = brand.dispName;
                    self.devcDef = Utils.merge({}, devcDef);
                });
            },
            // 查看资产定义详情
            getDevcDefDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.defId;
                //
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getMerchtDevcDefInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let devcDef = result.data;
                        if (Utils.isTrue(devcDef.normalized)) {
                            self.disableNormalized = true;
                        }
                        self.devcDef = Utils.merge({}, devcDef);
                        self.dbDevcDef = Utils.merge({}, devcDef);
                        self.devcFiles = Utils.merge([], devcDef.merchtDevcManuals);
                        self.tempOnlyDisabled = true;
                        if (Utils.isTrue(devcDef.tempOnly)) {
                            self.purchFlagDisabled = true;
                            self.vendorUknoFlagDisabled = true;
                        }
                        //
                        let imgFile = {
                            fileBrowseUrl: devcDef.imageUrl
                        };
                        self.imgFile = Utils.merge({}, imgFile);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 上传图片
            onBeforeUpload: function (fileItems, uploader) {
                if (fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                } else {
                    let name = fileItems[0].name;
                    if (!Utils.isNoB(name)) {
                        let hz = name.substring(name.lastIndexOf('.'), name.length);
                        if (hz != '.jpg' && hz != '.jpeg' && hz != '.png' && hz != '.webp') {
                            MsgBox.warning('允许的文件扩展名为：.jpg, .jpeg, .png, .webp');
                            return false;
                        }
                    }
                    let size = fileItems[0].size;
                    let sizeKB = size / 1024;
                    if (sizeKB > 1024) {
                        let sizeMB = (sizeKB / 1024).toFixed(2);
                        MsgBox.warning('最大支持1MB,当前' + sizeMB + 'MB');
                        return false;
                    }
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                if (result.type === 'info') {
                    let files = result.data.files || [];
                    if (files.length > 0) {
                        self.imgFile = files[0];
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            },
            removeUpload: function () {
                this.imgFile = null;
            },
            // 选择资料手册
            selectManuals: function () {
                let self = this;
                let devcFiles = self.devcFiles || [];
                let selectIds = devcFiles.pluck("id") || [];
                let params = {
                    checkBox: true,
                    selectIds: selectIds
                };
                showMerchtDevcManualSelectDlg(params, function (devcManualList, theDlg) {
                    devcManualList = devcManualList || [];
                    self.devcFiles = Utils.merge([], devcManualList);
                    theDlg.close();
                });
            },
            // 移除资料手册
            removeManuals: function (file) {
                let devcFiles = this.devcFiles || [];
                for (let i = 0; i < devcFiles.length; i++) {
                    let devcFile = devcFiles[i];
                    if (devcFile.fileUuid == file.fileUuid) {
                        devcFiles.splice(i, 1);
                        break;
                    }
                }
                this.devcFiles = Utils.merge([], devcFiles);
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        //
                        let devcDef = self.devcDef;
                        if (Utils.isNoB(devcDef.innerDevcCatId) || devcDef.innerDevcCatId == -1) {
                            result.type = 'warn';
                            result.message = '请选择资产分类!';
                        } else if (Utils.isNoB(devcDef.innerDevcBrandId) || devcDef.innerDevcBrandId == -1) {
                            result.type = 'warn';
                            result.message = '请选择资产品牌!';
                        } else {
                            let modelSpec = devcDef.model + devcDef.fixedSpec;
                            if (modelSpec.length > 75) {
                                result.type = 'warn';
                                result.message = '型号 + 规格的字数总和不能大于75';
                            } else if (Utils.isNoB(devcDef.innerCode)) {
                                result.type = 'warn';
                                result.message = '定义编码不能为空';
                            } else if (Utils.isNoB(devcDef.theUnit)) {
                                result.type = 'warn';
                                result.message = '单位不能为空';
                            } else {
                                //
                                devcDef.modelSpec = modelSpec;
                                devcDef.imageUrl = Utils.isNoB(self.imgFile) ? null : self.imgFile.fileBrowseUrl;
                                devcDef.manualIds = !Utils.isNoB(self.devcFiles) && self.devcFiles.length > 0 ? self.devcFiles.pluck("id") : [];
                                if (!Utils.isNoB(self.defId)) {
                                    devcDef.id = self.defId;
                                }
                                //
                                if (self.normalizedFlag) {
                                    let deviceKindList = self.deviceKindList || [];
                                    if (!Utils.isNoB(devcDef.assetKindId)) {
                                        if ((Utils.isNoB(devcDef.deprSpecId) || devcDef.deprSpecId == -1) && devcDef.assetType != 2) {
                                            result.type = 'warn';
                                            result.message = '折旧码不可为空';
                                        } else {
                                            deviceKindList.forEach(function (item) {
                                                if (item.id == devcDef.assetKindId) {
                                                    devcDef.assetKindName = item.name;
                                                    devcDef.assetKindCode = item.code;
                                                }
                                            });
                                            //
                                            result.type = 'info';
                                            result.data = devcDef;
                                        }
                                    } else {
                                        //
                                        result.type = 'info';
                                        result.data = devcDef;
                                    }
                                } else {
                                    if (!Utils.isNoB(self.defId) && JSON.toString(devcDef) == JSON.toString(self.dbDevcDef)) {
                                        devcDef.normalizedSub = false;
                                    }
                                    result.type = 'info';
                                    result.data = devcDef;
                                }
                            }
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
            titleChange() {
                if (Utils.isTrue(this.autoGeneratedTitle)) {
                    let devcDef = this.devcDef;
                    if (Utils.isNoB(devcDef.title) && !Utils.isNoB(devcDef.name) && !Utils.isNoB(devcDef.model) && !Utils.isNoB(devcDef.fixedSpec)) {
                        devcDef.title = devcDef.name + '' + devcDef.model + '' + devcDef.fixedSpec;
                        this.devcDef = Utils.merge({}, devcDef);
                    }
                }
            },
            flagChange() {
                let devcDef = this.devcDef;
                if (!devcDef.setupFlag || !devcDef.asmblFlag) {
                    devcDef.asmblWhileSetup = false;
                    this.devcDef = Utils.merge({}, devcDef);
                }
            },
            selectInnerCatDlg() {
                let self = this;
                let devcDef = this.devcDef;
                let selectIds = [];
                if (!Utils.isNoB(devcDef.innerDevcCatId)) {
                    selectIds = [devcDef.innerDevcCatId];
                }
                showDevcCatSelectDlg({
                    filter: {
                        relSysFlag: true,
                        disabled: false,
                        level: 3
                    },
                    selectIds: selectIds
                }, function (devcCat, theDlg) {
                    theDlg.close();
                    devcDef.innerDevcCatId = devcCat.id;
                    devcDef.innerDevcCatName = devcCat.name;
                    devcDef.innerDevcCode = devcCat.code;
                    devcDef.innerDevcCatFullName = devcCat.fullName;
                    if (!Utils.isNoB(devcCat.unit)) {
                        devcDef.theUnit = devcCat.unit;
                    }
                    devcDef.fiscalAcctAutoIn = devcCat.fiscalAcctAutoIn;
                    devcDef.durableLife = devcCat.durableLife;
                    devcDef.vendorUknoFlag = devcCat.vendorUknoFlag;
                    self.devcDef = Utils.merge({}, devcDef);
                });
            },
            selectInnerBrandDlg() {
                let self = this;
                let devcDef = this.devcDef;
                let selectIds = [];
                if (!Utils.isNoB(devcDef.innerDevcBrandId)) {
                    selectIds = [devcDef.innerDevcBrandId];
                }
                showDevcBrandSelectDlg({
                    filter: {
                        relSysFlag: true,
                        disabled: false
                    },
                    selectIds: selectIds
                }, function (devcBrand, theDlg) {
                    theDlg.close();
                    devcDef.innerDevcBrandId = devcBrand.id;
                    devcDef.innerDevcBrandName = devcBrand.name;
                    devcDef.innerDevcBrandCode = devcBrand.code;
                    if (Utils.isNoB(devcDef.brandId) && !Utils.isNoB(devcBrand.sysBrandId) && devcBrand.sysBrandId != -1) {
                        devcDef.brandId = devcBrand.sysBrandId;
                        devcDef.brandName = devcBrand.sysBrandName;
                    }
                    self.devcDef = Utils.merge({}, devcDef);
                });
            },
            getCustTagMetaFields: function () {
                let self = this
                let param = [{tagMetaTableName: 'mercht_devc_def', tagMetaRole: 2}]
                custTagMeataApi.getCustTagMetaFields(param, function (result) {
                    if (result.type == 'info') {
                        let tags = result.data
                        for (let i = 0; i < tags.length; i++) {
                            let tag = tags[i]
                            if (tag.fieldName == 'devcCustTag1') {
                                self.devcCustTag1 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled
                                }
                            } else if (tag.fieldName == 'devcCustTag2') {
                                self.devcCustTag2 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled
                                }
                            } else if (tag.fieldName == 'devcCustTag3') {
                                self.devcCustTag3 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(result.message)
                    }
                });
            },
            filterListValue(listItems, listVal) {
                let listValues = listItems.pluck('id')
                let reval = listValues.indexOf(listVal) == -1 ? null : listVal;
                return reval;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefSave.vue